import { useTheme } from "@emotion/react";
import { Card, CardActionArea, CardContent, Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import { Navigate } from "react-router-dom";

// ======================================================= //

const getDate = (timestamp) => {
    const d_ = new Date(timestamp);
    return `${d_.getDate()}-${d_.getMonth()}-${d_.getFullYear()}`;
}

// ------------------------------------------------------- //

export default function TableCard(props)
{
    const {table, index} = props;

    const {name, createdAt} = props.table;
    const {main} = useTheme().palette.primary;

    const [redirect, setRedirect] = useState(false);

    // ------------------------------------------------------- //

    if(redirect === true) {
        return <Navigate to={`/table/${table.id}`} />
    }

    // ------------------------------------------------------- //

    return(
        <Grid item xs={12} md={4} lg={3}>
            <Card 
                variant='outlined' 
                sx={{bgcolor: index % 2 === 0 ? main : ''}}                
            >
                <CardActionArea onClick={() => setRedirect(true)}>
                <CardContent>
                    <Typography variant="h5" component="div">
                        {name}
                    </Typography>
                    <Typography sx={{ mb: 1.5 }} color="text.secondary">
                        Created • {getDate(createdAt) === getDate(Date.now()) ? "Today" : getDate(createdAt)}
                    </Typography>

                    <Typography color="text.secondary" variant="caption">
                        Click to view
                    </Typography>
                </CardContent>
                </CardActionArea>
            </Card>
        </Grid>
    )
}

// ======================================================= //